module.exports = __webpack_public_path__ + "img/news_banner.00fad75a.png";